import { createContext, useContext, type ReactNode } from "react"

const ProjectCanvasModeContext = createContext({ readOnly: false })

export const ProjectCanvasModeProvider = ({
	children,
	readOnly,
}: {
	children: ReactNode
	readOnly: boolean
}) => (
	<ProjectCanvasModeContext.Provider value={{ readOnly }}>
		{children}
	</ProjectCanvasModeContext.Provider>
)

export const useProjectCanvasMode = () => useContext(ProjectCanvasModeContext)
